import { deleteCookie, getCookie, setCookie } from '@beef/utils';
import { CAPTCHA_ACCESS_COOKIE_NAME, CAPTCHA_ACTIVE_MESSAGE_ID, CAPTCHA_QUEUED_MESSAGES, CAPTCHA_RECREATE_KEY, CAPTCHA_RETRY_KEY, CAPTCHA_TARGET_KEY } from "../../../../shared/config";
export var setTokensToCookies = function setTokensToCookies(accessToken) {
  setCookie({
    name: CAPTCHA_ACCESS_COOKIE_NAME,
    value: accessToken,
    maxAge: 60000
  });
};
export var getTokenData = function getTokenData() {
  var accessToken = getCookie(CAPTCHA_ACCESS_COOKIE_NAME);
  if (!accessToken) {
    return undefined;
  }
  return accessToken;
};
export var changeCaptchaCounterStorage = function changeCaptchaCounterStorage(state, type, count) {
  state[type === 'retry' ? 'retryCount' : 'recreateCount'] = count;
  var key = type === 'retry' ? CAPTCHA_RETRY_KEY : CAPTCHA_RECREATE_KEY;
  if (count === 0) {
    deleteCookie(key);
  } else {
    setCookie({
      name: key,
      value: count
    });
  }
};
export var saveTargetCaptcha = function saveTargetCaptcha(captcha) {
  sessionStorage.setItem(CAPTCHA_TARGET_KEY, JSON.stringify(captcha));
};
export var saveActiveCaptchaMessageId = function saveActiveCaptchaMessageId(id) {
  if (id) {
    setCookie({
      name: CAPTCHA_ACTIVE_MESSAGE_ID,
      value: id === null || id === void 0 ? void 0 : id.toString()
    });
  }
};
export var saveQueuedMessages = function saveQueuedMessages(messages) {
  sessionStorage.setItem(CAPTCHA_QUEUED_MESSAGES, JSON.stringify(messages));
};